module.exports = __webpack_public_path__ + "img/Redwoods.161c57b7.jpg";